export enum AllergenLogic {
	Positive = 'Positive',
	Negative = 'Negative',
	MayContain = 'MayContain',
}
